export const EMAIL_TYPE = 1;
export const SMS_TYPE = 2;
export const FAX_TYPE = 3;
